// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var TestSvg = require("./TestSvg.bs.js");
var KeyTrainer = require("./KeyTrainer.bs.js");
var MM_cmp_root = require("./metamath/ui/MM_cmp_root.bs.js");
var JsonParseView = require("./JsonParseView.bs.js");
var TextFieldDemo = require("./TextFieldDemo.bs.js");
var Expln_React_ViewSelector = require("@expln/utils/src/main/Expln_React_ViewSelector.bs.js");

function MainView(Props) {
  return React.createElement(Expln_React_ViewSelector.make, {
              allViews: [
                {
                  id: "1",
                  title: "JsonParseView",
                  render: (function (param) {
                      return React.createElement(JsonParseView.make, {});
                    })
                },
                {
                  id: "2",
                  title: "TestSvg",
                  render: (function (param) {
                      return React.createElement(TestSvg.make, {});
                    })
                },
                {
                  id: "3",
                  title: "MuiDemo",
                  render: (function (param) {
                      return React.createElement(TextFieldDemo.make, {});
                    })
                },
                {
                  id: "4",
                  title: "KeyTrainer",
                  render: (function (param) {
                      return React.createElement(KeyTrainer.make, {});
                    })
                },
                {
                  id: "5",
                  title: "MM_cmp_context_loader",
                  render: (function (param) {
                      return React.createElement(MM_cmp_root.make, {});
                    })
                }
              ],
              defaultViewId: "5"
            });
}

var make = MainView;

exports.make = make;
/* react Not a pure module */
